
import { Component, Mixins, Prop } from 'vue-property-decorator';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import { NodeEliot } from '~/interfaces/eliot.interface';
import TreeMixin from '~/mixins/tree.mixin';
import { ConfigModule } from '~/store/modules/config';
import { EliotModule } from '~/store/modules/eliot';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component({
    components: {
        NetatmoIcon,
    },
})
export default class EliotTreeNode extends Mixins(DarkThemeInfoMixin, TreeMixin) {
    @Prop() readonly item!: NodeEliot;

    getText(id: string) {
        return this.areGatewaysShown(id) ? 'hide-password' : 'show-password';
    }

    isStandaloneDevice(deviceId: string) {
        const device = EliotModule.deviceFromId(deviceId);
        return device ? EliotModule.isStandaloneDevice(device) : false;
    }

    areGatewaysShown(id: string) {
        return EliotModule.areGatewaysShown(id);
    }

    async toggleDisplayGateways(plantId: string) {
        await EliotModule.clickShowGateway(plantId);

        if (!EliotModule.isPlantGatewayShown(plantId)) {
            this.$emit('remove-gateway-nodes', plantId);
        }
    }

    getGateways(plantId: string) {
        return EliotModule.gatewaysOfPlant(plantId);
    }

    goToNode(id: string, type?: string) {
        const { userIdentifier } = this.$route.params;
        let path = `${userIdentifier ? `/${ConfigModule.supportAppNameBase}/eliotuser/` + userIdentifier : `/${ConfigModule.supportAppNameBase}`}`;
        if (type === 'plant') {
            path = `${path}/plant/${id}`;
        } else if (type === 'gateway') {
            path = `${path}/eliotgateway/${id}`;
        }
        if (path === this.$route.path) {
            return;
        }
        this.$router.push({ path });
    }

    isDeviceSelected(macAddress: string, id: string) {
        return EliotModule.currentGatewayId === id || EliotModule.currentGatewayId === macAddress;
    }

    isNodeActive(id: string, type?: string) {
        if (type === 'plant') {
            return EliotModule.currentPlantId === id;
        } else if (type === 'gateway') {
            return EliotModule.currentGatewayId === id;
        }
    }
}
